import LegalPage from "../../components/LegalPage/LegalPage";

const sections = [
  {
    heading: "Eligibility",
    paragraphs: [
      "Unopened products may be eligible for a refund within 30 days of delivery when accompanied by valid order details.",
      "If an item arrives damaged, incorrect, or unusable, contact support promptly so we can review the issue and make it right.",
    ],
  },
  {
    heading: "Non-Refundable Charges",
    items: [
      "Original shipping costs are generally non-refundable unless the issue was caused by Chill Tree.",
      "Refunds may be denied for products that show substantial use, tampering, or intentional damage.",
    ],
  },
  {
    heading: "How Refunds Are Issued",
    paragraphs: [
      "Approved refunds are returned to the original payment method whenever possible.",
      "Processing times depend on your payment provider and can vary after the refund is submitted.",
    ],
  },
];

export default function RefundPolicy() {
  return (
    <LegalPage
      eyebrow="Legal"
      title="Refund Policy"
      intro="Our goal is to keep returns and refund requests clear, fair, and easy to resolve."
      lastUpdated="April 14, 2026"
      sections={sections}
    />
  );
}




